module.exports = __webpack_public_path__ + "img/red.17d1baf4.png";